const colors = {
  PRIMARY_LIGHT: '#4a7cc7',
  PRIMARY: '#1e5ba5',
  PRIMARY_DARK: '#143d73',
  SECONDARY: '#bed6f3',
  ACCENT: '#ff7f00',
  TEXT: '#050315',
  TEXT_GREY: '#9e9e9e',
  BACKGROUND: '#fbfbfe',
  GREY: '#666666',
  WHITE: '#ffffff',
  SUCCESS: '#14AE5C',
  ERROR: '#FF0000',
};

export default colors;
